<template>
  <div class="dialog-confirm-cancel">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <span class="title">
          {{ $t('transactions.dialog.confirm_cancel.title') }}
        </span><br>
        <span class="text-error">{{ error }}</span>
      </div>
      <div class="main">
        <div class="group-label">
          <label class="label">{{ $t('transactions.id') }}: p{{ transaction.id }}</label><br>
          <label class="label">{{ transaction.shop.name }} ({{ $dayjs(transaction.transaction_datetime).format('YY/MM/DD  HH:mm') }})</label><br>
        </div>
        <span class="content">
          <span>{{ getStaff() }}さんが{{ getUser() }}さんから </span><br>
          <span>{{ transaction.point_formated }}ココロンを受け取った</span>
        </span>
      </div>
      <div class="footer">
        <el-button type="primary" @click="handleCancel" class="btn btn-edit">{{ $t('transactions.btn_label.cancel_dialog') }}</el-button>
        <el-button @click="handleClose" class="btn btn-back">{{ $t('transactions.btn_label.not_confirm_cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { cancel } from '../../api/transaction'
  export default {
    props: {
      openFormCancel: { type: Boolean, required: true, default: false },
      transaction: { type: Object, required: true, default: {} },
    },
    emits: ['isClosePopupCancel', 'isOpenNoti'],
    data() {
      return {
        outerVisible: false,
        innerVisible: false,
        dialog: '',
        isClose: false,
        loading: false,
        error: ''
      };
    },
    methods: {
      handleClose() {
        this.$emit('isClosePopupCancel');
      },
      handleCancel() {
        this.loading = true;
        document.querySelector(".el-dialog__body").classList.add("disabled");
        cancel(this.transaction.id)
        .then(response => response.json())
        .then(response => {
          if (response.status_code === 200) {
            this.handleClose();
            this.$emit('isOpenNoti', true);
          } else {
            this.error = this.$t('errors.cancel_fail');
          }
        })
        .catch((error) => {
        })
        .finally(() => {
          document.querySelector(".el-dialog__body").classList.remove("disabled");
          this.loading = false;
        });
      },
      getStaff() {
        if (this.transaction.staff) {
          return (this.transaction.staff.first_name ? this.transaction.staff.first_name : '')
          + (this.transaction.staff.last_name ? this.transaction.staff.last_name : '')
            + ' (' + this.transaction.staff.nickname + ')';
        }
        return '';
      },
      getUser() {
        if (this.transaction.user) {
          return (this.transaction.user.first_name ? this.transaction.user.first_name : '')
          + (this.transaction.user.last_name ? this.transaction.user.last_name : '')
            + ' (' + this.transaction.user.nickname + ')';
        }
        return '';
      },
    },

    created() {
      this.dialog = this.openFormCancel;
    }
  }
</script>

<style lang="scss" scoped>
  .dialog-confirm-cancel {
    text-align: center;
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      text-align: center;
      font-weight: 700;
    }
    .main {
      letter-spacing: 0.75px;
      color: #000000;
      text-align: center;
      font: normal normal normal 14px/35px Kozuka Gothic Pr6N;
      letter-spacing: 1.4px;
      .content {
        font-weight: 700;
        span {
          font-size: 16px;
          letter-spacing: 1.6px;
          line-height: 35px;
        }
      }
      .group-label {
        padding: 20px 0;
      }
    }
    .footer {
      margin-top: 30px;
      text-align: center;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 200px;
        height: 50px;
        border-radius: 25px !important;
      }
      .btn-edit {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
      .btn-back {
        background: #969696 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #969696;
        --el-button-hover-border-color: #969696;
        --el-button-border-color: #969696;
      }
    }
  }
</style>
